import ProfileForm from './ProfileForm'
import PasswordForm from './PasswordForm'

export {
  ProfileForm,
  PasswordForm
}



// WEBPACK FOOTER //
// ./src/views/Settings/components/index.js